import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, CheckCircle2 } from 'lucide-react';

const CTASection = ({ onOpenContactForm }) => {
  return (
    <section className="py-24 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #2A1118 0%, #3D1019 50%, #2A1118 100%)' }}>
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 70% 30%, rgba(201,168,92,0.3) 0%, transparent 50%)' }}></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold-400 mb-4">Don't Wait</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-4">
            <span className="text-white">Ready to Secure</span><br/>
            <span className="text-gold-400">Your Brand Identity?</span>
          </h2>
          <p className="text-wine-300 leading-relaxed">Every day without trademark protection puts your brand at risk. Our expert attorneys handle everything from filing to approval.</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 max-w-5xl mx-auto mb-10">
          {['Federal trademark protection across all 50 states', 'Comprehensive USPTO database search before filing', 'Expert handling of office actions and objections', 'Amazon Brand Registry enrollment support included', 'Dedicated case manager for every application', 'Ongoing brand monitoring and renewal support'].map((text, i) => (
            <div key={i} className="group flex items-start gap-3 bg-wine-900/40 rounded-lg p-4 border border-wine-700/40 hover:border-gold-400 hover:bg-wine-800/70 hover:shadow-lg hover:shadow-gold-500/10 hover:-translate-y-0.5 transition-all duration-300 cursor-default">
              <CheckCircle2 className="w-5 h-5 text-gold-400 mt-0.5 flex-shrink-0 group-hover:text-gold-400 group-hover:scale-110 transition-transform duration-300" />
              <span className="text-wine-200 text-sm group-hover:text-white transition-colors duration-300">{text}</span>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Button data-testid="cta-section-btn" onClick={onOpenContactForm} className="bg-gold-500 hover:bg-gold-400 text-wine-950 font-semibold px-8 py-5 text-base shadow-lg shadow-gold-500/20 transition-all hover:shadow-gold-400/30">
            Start Your Filing Today <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
